import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";
const KMCFunctions = () => {
  return (
    <>
      {/* Slider */}
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> About Us - KMC Functions </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <KMCDepartmentLeftManu />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 inner-title">
                    <h3 className="fontSizeClass"> KMC Functions </h3>
                  </div>

                  <div className="col-lg-6 about-head1 fun1">
                    <h4 className="fontSizeClass">
                      According to Section 29 of the KMC Act, KMC has the
                      following Obligatory Functions:
                    </h4>
                    <ul className="kmc-function-list">
                      {[
                        "Supply of drinking water in the KMC area.",
                        "Cleaning and removal of filth, rubbish and other obnoxious matters.",
                        "Laying and maintaining Public Streets.",
                        "Provision of public lighting.",
                        "Sewerage and drainage provision in KMC area.",
                        "Naming and numbering of streets and premises.",
                        "Planting of trees on roadsides and elsewhere.",
                        "The laying out or maintenance of public parks, gardens or recreation grounds.",
                        "Health and welfare functions.",
                        "Regulation of trade through licensing.",
                        "Regulation of trade through licensing.",
                        "Provision of municipal markets and slaughter-houses.",
                        "Maintenance of heritage monuments.",
                        "Record keeping and statistics.",
                        "Providing by itself or by an agency, means of supply of water for fire-fighting.",
                      ].map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-lg-6 about-head1 fun1">
                    <h4 className="fontSizeClass">
                      According to Section 30 of the KMC Act, KMC has the
                      following Discretionary Functions:
                    </h4>
                    <ul className="kmc-function-list">
                      {[
                        "Furtherance of education.",
                        "Establishment and maintenance of libraries, museums, zoological collections.",
                        "Survey of building and lands.",
                        "Providing music and entertainment in public places or public resorts.",
                        "Organization and management of fairs and exhibitions.",
                        "Acquisition of movable and immovable property for purpose mentioned before.",
                        "Construction of rest house, poor house, infirmaries, children homes, house of deaf and dumb and disabled persons.",
                        " Construction and maintenance of cattle ponds.",
                        "Purchase, construction and maintenance of house for employees.",
                        " Welfare of employees.",
                        "Establishment and maintenance of hospitals and dispensaries.",
                        "Provision of swimming pools, bathing place and other institutions for improvement of community health.",
                        "Construction/maintenance of warehouse and garages sheds and cattle biers.",
                        "Provision of housing accommodation for inhabitants.",
                        "Any measures to promote public safety, health sanitation.",
                      ].map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMCFunctions;
